import { Header } from "@mantine/core";
import Link from "next/link";
import React from "react";
import { HEADER_HEIGHT } from "../web/Header";
import Image from 'next/image';

export const AuthHeader = ({ children }) => {
  return (
    <Header height={HEADER_HEIGHT} className='my-3 border-0 md:my-8'>
      <div className='flex items-center justify-between px-5 py-3 md:px-20'>
        <Link href={"/"}>
          <Image width={172} height={70} src='/images/logo.png' alt='Million Experts' />
        </Link>
        {children}
      </div>
    </Header>
  );
};
